<template>
  <div class="flex flex-col">
    <h2>Reportes</h2>

    <div class="flex flex-col lg:flex-row gap-4 lg:gap-6 mt-6 items-start">
      <status-side-nav :options="statusNavOptions" />

      <router-view class="flex-1 min-w-0 w-full" />
    </div>
  </div>
</template>

<script>
import StatusSideNav from "@/components/ui/StatusSideNav";
export default {
  name: "Reports",

  components: {
    StatusSideNav,
  },

  computed: {
    statusNavOptions() {
      return [
        {
          label: "Bisemanal",
          icon: "📆",
          to: { name: "biweekly" },
          active: this.$route.name === "biweekly",
        },
        {
          label: "Mensual",
          icon: "📅",
          to: { name: "monthly" },
          active: this.$route.name === "monthly",
        },
      ];
    },
  },

  created() {
    this.$store.commit("setSelectedTab", "reports");
  },
};
</script>
